import * as v from 'valibot'

// Validate environment variables immediately
function validateEnv() {
  const publicEnvSchema = v.object({
    EXPO_PUBLIC_SUPABASE_URL: v.pipe(v.string(), v.url()),
    EXPO_PUBLIC_SUPABASE_ANON_KEY: v.pipe(v.string(), v.minLength(1)),

    // client checking:
    EXPO_PUBLIC_CREEM_PRODUCT_ID_PERSONAL: v.pipe(v.string(), v.minLength(1)),
    EXPO_PUBLIC_CREEM_PRODUCT_ID_TEAM: v.pipe(v.string(), v.minLength(1)),
    EXPO_PUBLIC_CREEM_PERSONAL_LINK: v.pipe(v.string(), v.url()),
    EXPO_PUBLIC_CREEM_TEAM_LINK: v.pipe(v.string(), v.url()),
  })

  const parsedEnvResult = v.safeParse(publicEnvSchema, {
    EXPO_PUBLIC_SUPABASE_URL: process.env.EXPO_PUBLIC_SUPABASE_URL,
    EXPO_PUBLIC_SUPABASE_ANON_KEY: process.env.EXPO_PUBLIC_SUPABASE_ANON_KEY,
    EXPO_PUBLIC_CREEM_PRODUCT_ID_PERSONAL: process.env.EXPO_PUBLIC_CREEM_PRODUCT_ID_MINI,
    EXPO_PUBLIC_CREEM_PRODUCT_ID_TEAM: process.env.EXPO_PUBLIC_CREEM_PRODUCT_ID_TEAM,
    EXPO_PUBLIC_CREEM_PERSONAL_LINK: process.env.EXPO_PUBLIC_CREEM_MINI_LINK,
    EXPO_PUBLIC_CREEM_TEAM_LINK: process.env.EXPO_PUBLIC_CREEM_TEAM_LINK,
  })

  if (!parsedEnvResult.success) {
    console.error(
      '❌ Invalid public environment variables:',
      JSON.stringify(parsedEnvResult.issues, null, 2),
    )
    throw new Error(
      `Invalid environment variables: ${JSON.stringify(parsedEnvResult.issues, null, 2)}`,
    )
  }

  return parsedEnvResult.output
}

// This will run immediately when the module is loaded
export const publicEnv = validateEnv()
export const isPublicEnvValid = () => !!validateEnv()
